function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 1)",
  stroke: "#C59353",
  strokeWidth: 2,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.599
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 60.5,
  cy: 60,
  rx: 59.5,
  ry: 59
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M61 55l.376 210.5"
}));

function SvgGroup22(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 121 268"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjEgMjY4Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgb3BhY2l0eT0iLjU5OSI+CiAgICAgICAgPGcgc3Ryb2tlPSIjQzU5MzUzIiBzdHJva2Utd2lkdGg9IjIiPgogICAgICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTAzOSAtMTA5OSkgdHJhbnNsYXRlKDEwMzkgMTEwMCkiPgogICAgICAgICAgICAgICAgPGVsbGlwc2UgY3g9IjYwLjUiIGN5PSI2MCIgcng9IjU5LjUiIHJ5PSI1OSIvPgogICAgICAgICAgICAgICAgPHBhdGggc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgZD0iTTYxIDU1TDYxLjM3NiAyNjUuNSIvPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgGroup22 as ReactComponent };